module.exports = __webpack_public_path__ + "static/media/thermostat_error.f8ada0b1.svg";